package kz.dentalcrm.app.screens.login.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface LoginViewSideEffect : ViewSideEffect {
    data object NavigateToMain : LoginViewSideEffect
}
